import { useEffect } from 'react';
import type { LectTerminationConsequencesResponse } from 'src/apis/contract-management/types';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  url: string;
};

type RequestOptions = {
  url: string;
};

export function useLectTerminationConsequences({ url }: HookConfig) {
  const lectTerminationConsequences = useAxios(
    (axios, baseConfig, { url }: RequestOptions) =>
      axios.request<LectTerminationConsequencesResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: false }
  );

  useEffect(() => {
    lectTerminationConsequences.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, [url]);

  return lectTerminationConsequences;
}

export type LectTerminationConsequencesRequest = ReturnType<
  typeof useLectTerminationConsequences
>;
